<template>
  <div class="zghBox">
    <div class="classify">
      <div class="left">
        <span class="status">状态：</span>
        <span
          @click="setStatusAct(0, null)"
          :class="statusAct === 0 ? 'act' : 'statusList'"
          >全部</span
        >
        <!--        <span-->
        <!--          @click="setStatusAct(1, '已审核')"-->
        <!--          :class="statusAct === 1 ? 'act' : 'statusList'"-->
        <!--        >已审核</span-->
        <!--        >-->
        <span
          @click="setStatusAct(1, 2)"
          :class="statusAct === 1 ? 'act' : 'statusList'"
          >已发布</span
        >
        <span
          @click="setStatusAct(2, 1)"
          :class="statusAct === 2 ? 'act' : 'statusList'"
          >审核中</span
        >
        <span
          @click="setStatusAct(3, 3)"
          :class="statusAct === 3 ? 'act' : 'statusList'"
          >未通过</span
        >
        <span
          @click="setStatusAct(4, 4)"
          :class="statusAct === 4 ? 'act' : 'statusList'"
          >已下架</span
        >
        <span
          @click="setStatusAct(5, 0)"
          :class="statusAct === 5 ? 'act' : 'statusList'"
          >草稿</span
        >
      </div>
      <div class="right">
        <span class="time">时间：</span>
        <DatePicker
          :value="TimeValue"
          format="yyyy/MM/dd"
          @on-change="handleChange"
          type="daterange"
          placement="bottom-end"
          placeholder="Select date"
          style="width: 220px"
        ></DatePicker>
        <Input
          v-model="search"
          placeholder="请输入标题进行搜索"
          class="searchinput"
        >
          <Icon @click="handleClick" type="ios-search" slot="suffix" />
        </Input>
      </div>
    </div>

    <div class="list">
      <div class="box" v-for="item in list" :key="item.articleId">
        <div class="left">
          <img
            v-if="item.cover"
            v-lazy="`${$global.imgUrl}${item.cover}`"
            alt=""
          />
          <div class="msg">
            <div class="top">
              <span :class="item.status | colored">{{item.status | type}}</span>
              <span></span>
              <span style="margin-right: 10px">[{{ item.perName }}]</span>
              {{ item.title }}
            </div>
            <div v-if="item.status === 3">
              <span >原因：</span>
              <span>{{ item.reason }}</span>
            </div>
            <div v-if="item.status === 2" class="read">
              <span class="key">
                阅读量：<span class="value">{{item.readPv ? item.readPv : 0}}</span>
              </span>
              <span class="key">
                收藏量：<span class="value">{{item.collectPv ? item.collectPv : 0}}</span>
              </span>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="time">{{ item.createTime | time }}</div>
          <div class="edit">
            <template v-if="item.status === 2">
              <span class="blue" @click="openDrawer(item)">详细信息</span>
              <span class="black">修改</span>
              <span class="blue" @click="del(item)">删除</span>
            </template>
            <template v-if="item.status === 0">
              <span @click="edit(item)" class="blue">修改</span>
              <span @click="del(item)" class="blue">删除</span>
            </template>
            <template v-if="item.status === 3">
              <span @click="edit(item)" class="blue">修改</span>
              <span class="blue" @click="del(item)">删除</span>
            </template>
            <template v-if="item.status === 1">
              <span class="black">修改</span>
              <span class="black">删除</span>
            </template>
            <template v-if="item.status === 4">
              <span class="black">修改</span>
              <span class="blue" @click="del(item)">删除</span>
            </template>
          </div>
        </div>
      </div>
    </div>
    <Paging
      :total="total"
      :curPage="page"
      :limit="10"
      :showPage="5"
      @changePager="handlePager"
    ></Paging>
    <Drawer :mask-closable="false" width="769" v-model="detailsShow">
      <DrawerDetail v-if="detailsShow" :id="drawerId"/>
    </Drawer>
  </div>
</template>

<script>
import Paging from "@/components/paging/index.vue";
import DrawerDetail from "./drawerDetail.vue";

export default {
  name: "zgh",
  components: {
    Paging,
    DrawerDetail
  },
  data() {
    return {
      TimeValue: [null, null],
      search: null,
      statusAct: 0,
      page: 1,
      total: 0,
      list: [],
      status: null,
      detailsShow: false,
      drawerId: '',
    };
  },
  created() {
    this.getList();
  },
  filters: {
    type: function (num) {
      if (num === 2) {
        return "已发布";
      } else if (num === 1) {
        return "审核中";
      } else if (num === 3) {
        return "未通过";
      } else if (num === 0) {
        return "草稿";
      } else if (num === 4) {
        return `已下架`;
      }
    },
    colored: function (num) {
      if (num === 2) {
        return "send";
      } else if (num === 0) {
        return "edit";
      } else if (num === 3) {
        return "pass";
      } else if (num === 1) {
        return "ing";
      } else if (num === 4) {
        return `down`;
      }
    },
    time: function (time) {
      let year = new Date(time).getFullYear();
      let month = new Date(time).getMonth() + 1;
      month < 10 ? (month = `0${month}`) : month;
      let day = new Date(time).getDate();
      day < 10 ? (day = `0${day}`) : day;
      let hours = new Date(time).getHours();
      hours = hours.toString().length === 2 ? hours : "0" + hours;
      let minutes = new Date(time).getMinutes();
      minutes = minutes.toString().length === 2 ? minutes : "0" + minutes;
      let seconds = new Date(time).getSeconds();
      seconds = seconds.toString().length === 2 ? seconds : "0" + seconds;
      if (isNaN(year)) {
        return "";
      }
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
  },
  methods: {
    // 打开详细信息抽屉
    openDrawer(e) {
      this.detailsShow = true
      this.drawerId = e.id
    },
    setStatusAct(i, status) {
      this.statusAct = i;
      this.status = status;
      this.page = 1;
      this.getList();
    },
    edit(e) {
      let { id } = e;
      this.$router.push(`/zghForm?id=${id}&title=征稿函`);
    },
    del(e) {
      this.$Modal.confirm({
        title: '操作确认',
        content: `<p>是否删除<${e.title}>?删除后无法恢复</p>`,
        onOk: async () => {
          const res = await this.$apis.userServe.zghdel({ id: e.id });
          if (res.resultCode === "200") {
            this.$Message.success("删除成功");
            await this.getList();
          }
        },
        onCancel: () => {
          this.$Message.info('已取消删除操作');
        }
      });
    },
    async donw(e) {
      const res = await this.$apis.userServe.zghxz({ id: e.id });
      if (res) {
        await this.getList();
      }
    },
    handlePager(e) {
      this.page = e;
      this.getList();
    },
    handleChange(value) {
      this.page = 1;
      this.getList();
    },
    handleClick() {
      this.page = 1;
      this.getList();
    },
    async getList() {
      let obj = {
        pageNo: this.page,
        pageSize: 10,
        title: this.search,
        beginTime: this.TimeValue[0],
        endTime: this.TimeValue[1],
        status: this.status,
      };
      const { content } = await this.$apis.userServe.zghList(obj);
      const { page } = content;
      let { total } = page;
      this.total = Number(total);
      this.list = page.list;
    },
  },
};
</script>

<style lang="scss" scoped>
.zghBox {
  padding-top: 30px;
  width: 1200px;

  .classify {
    display: flex;
    height: 30px;
    justify-content: space-between;
    width: 1200px;

    .right {
      height: 30px;

      .time {
        //background: yellow;
        line-height: 30px;
        margin-right: 10px;
      }

      .searchinput {
        width: 351px;
        //height: 41px;
        border-radius: 10px;
        margin-left: 33px;
      }
    }

    .left {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 30px;
      cursor: pointer;

      .status {
        margin-right: 3px;
      }

      .statusList {
        margin-left: 10px;
        margin-right: 10px;
      }

      .act {
        margin-left: 10px;
        margin-right: 10px;
        color: #0101f3;
      }
    }
  }

  .list {
    margin-top: 30px;

    .box {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      padding: 20px 48px 10px;
      width: 1200px;
      min-height: 130px;
      background: #ffffff;
      box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);

      .right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 190px;

        .time {
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          text-align: right;
        }

        .edit {
          text-align: right;
          span {
            margin-left: 25px;
            cursor: pointer;
          }

          .blue {
            color: rgba(11, 53, 197, 1);
          }

          .black {
            color: #999999;
          }
        }
      }

      .left {
        display: flex;
        flex: 1;

        img {
          width: 122px;
          height: 122px;
        }

        .msg {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 100%;
          font-size: 14px;

          .top {
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;

            .edit {
              color: #ff9415;
              margin-right: 10px;
              //display: inline-block;
              //border-right: #FF9415 1px solid;
              //padding-right: 10px;
              //height: 20px;
            }

            .edit + span {
              margin-bottom: -2px;
              margin-right: 10px;
              width: 2px;
              height: 15px;
              background: #ff9415;
              display: inline-block;
            }

            .send {
              color: #10286f;
              margin-right: 10px;
              //display: inline-block;
              //border-right: #FF9415 1px solid;
              //padding-right: 10px;
              //height: 20px;
            }

            .send + span {
              margin-bottom: -2px;
              margin-right: 10px;
              width: 2px;
              height: 15px;
              background: #10286f;
              display: inline-block;
            }

            .ing {
              color: #8073d2;
              margin-right: 10px;
              //display: inline-block;
              //border-right: #FF9415 1px solid;
              //padding-right: 10px;
              //height: 20px;
            }

            .ing + span {
              margin-bottom: -2px;
              margin-right: 10px;
              width: 2px;
              height: 15px;
              background: #8073d2;
              display: inline-block;
            }

            .pass {
              color: #ff0000;
              margin-right: 10px;
              //display: inline-block;
              //border-right: #FF9415 1px solid;
              //padding-right: 10px;
              //height: 20px;
            }

            .pass + span {
              margin-bottom: -2px;
              margin-right: 10px;
              width: 2px;
              height: 15px;
              background: #ff0000;
              display: inline-block;
            }

            .down {
              color: #dc727c;
              margin-right: 10px;
              //display: inline-block;
              //border-right: #FF9415 1px solid;
              //padding-right: 10px;
              //height: 20px;
            }

            .down + span {
              margin-bottom: -2px;
              margin-right: 10px;
              width: 2px;
              height: 15px;
              background: #dc727c;
              display: inline-block;
            }
          }

          .read {
            width: 530px;

            .key {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #666666;
              margin-right: 25px;
            }
          }
        }
      }
    }
  }
}
::v-deep .ivu-drawer-close {
  top: 0;
  right: 0;
  left: 0;
  width: 36px;
  height: 36px;
  border-radius: 0 0 36px 0;
  background-color: rgba(55,55,55,.6);
  .ivu-icon-ios-close {
    top: -2px;
    left: -2px;
    font-size: 34px;
    color: #fff;
  }
}
</style>
